import { RuleSection } from '../types';

export const riverAbbotSections: RuleSection[] = [
  {
    "id": "river-setup",
    "title": "Rzeka: przygotowanie nowego początku",
    "requiredModuleIds": [
      "river"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "polish-base-c3",
      "corpus-base"
    ],
    "keywords": [
      "rzeka",
      "zrodlo"
    ],
    "level": "basic",
    "hubGroup": "Rzeka",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Rzeka zastępuje zwykły kafelek startowy i tworzy wspólny początek krajobrazu. Najpierw powstaje jej bieg od źródła do jeziora, a dopiero później dobiera się zwykłe kafelki. Dzięki temu wszyscy zaczynają przy tym samym układzie, ale Rzeka nie zmienia podstawowych zasad dopasowania terenów ani punktowania."
      },
      {
        "type": "numberedList",
        "items": [
          "Oddziel kafelek źródła i kafelek jeziora od pozostałych kafelków Rzeki.",
          "Połóż źródło na środku wolnego stołu. Nie używaj przy tym zwykłego kafelka startowego.",
          "Potasuj zakryte pozostałe kafelki Rzeki; jezioro zachowaj jako kafelek kończący jej bieg.",
          "Rozgrywaj kolejno kafelki Rzeki, aż jezioro zakończy jej układ.",
          "Dopiero po Rzece przejdź do zwykłej, zakrytej puli kafelków podstawy i aktywnych dodatków."
        ]
      },
      {
        "type": "image",
        "imageId": "river-bend-rule",
        "alt": "Zakaz dwóch kolejnych zakrętów.",
        "caption": "Zakręty Rzeki"
      },
      {
        "type": "table",
        "headers": ["Stan", "Decyzja", "Kroki", "Wynik", "Dlaczego jest poprawny"],
        "rows": [
          [
            "Anna, Bartek i Celina grają podstawą z Rzeką.",
            "Przygotowują Rzekę przed zwykłą pulą kafelków.",
            "1. Kładą źródło na środku. 2. Odkładają jezioro na koniec biegu. 3. Tasują pozostałe kafelki Rzeki. 4. Zwykłe kafelki zostawiają zakryte na później.",
            "Pierwsze tury tworzą Rzekę, a następne korzystają ze zwykłej puli.",
            "Rzeka zastępuje zwykły start, lecz jest tylko pierwszą częścią wspólnego krajobrazu."
          ]
        ]
      },
      {
        "type": "commonMistake",
        "text": "Położenie zwykłego kafelka startowego wraz ze źródłem. Korekta: przy aktywnej Rzece źródło jest początkiem krajobrazu."
      },
      {
        "type": "crossReference",
        "sectionId": "river-rules",
        "label": "Następnie: układanie biegu Rzeki"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Źródło rozpoczyna krajobraz, a jezioro kończy Rzekę.",
          "Nie używaj zwykłego kafelka startowego.",
          "Najpierw rozgrywa się kafelki Rzeki, potem zwykłą pulę.",
          "Rzeka nie zmienia podstawowego celu gry ani punktowania."
        ]
      },
      {
        "type": "qa",
        "question": "Czy przy Rzece używa się zwykłego kafelka startowego?",
        "answer": "Nie. Źródło Rzeki zastępuje zwykły kafelek startowy."
      }
    ],
    "imageIds": [
      "river-bend-rule"
    ]
  },
  {
    "id": "river-rules",
    "title": "Rzeka: układanie biegu i terenów przy wodzie",
    "requiredModuleIds": [
      "river"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "polish-base-c3"
    ],
    "keywords": [
      "rzeka"
    ],
    "level": "basic",
    "hubGroup": "Rzeka",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Kafelki Rzeki dokłada się kolejno do jej otwartego biegu. Woda nie jest drogą i nie można na niej wystawić figury, ale na tym samym kafelku mogą znajdować się zwykłe miasta, drogi i pola. Nadal sprawdzasz wszystkie zwykłe krawędzie terenu, tak jak przy każdym innym kafelku."
      },
      {
        "type": "numberedList",
        "items": [
          "Dobierz kafelek Rzeki i połącz jego wodę z otwartym biegiem Rzeki.",
          "Sprawdź pozostałe styki kafelka z krajobrazem; zwykłe tereny muszą do siebie pasować.",
          "Nie twórz dwóch kolejnych zakrętów w tę samą stronę, jeśli powodowałoby to zakazane zawinięcie biegu.",
          "Po dołożeniu możesz wystawić figurę tylko na zwykłym obszarze kafelka, nigdy na wodzie.",
          "Po dołożeniu jeziora Rzeka jest zakończona i przechodzicie do zwykłych kafelków."
        ]
      },
      {
        "type": "warning",
        "text": "Nie układaj dwóch zakrętów z rzędu w tę samą stronę, jeśli tworzy to zakazane zawinięcie."
      },
      {
        "type": "bulletList",
        "items": [
          "Rzeka nie jest drogą.",
          "Nie stawiaj meepla na wodzie.",
          "Możesz stawiać na pozostałych elementach kafelka.",
          "Pola po bokach rzeki są rozdzielone, chyba że grafika łączy."
        ]
      },
      {
        "type": "table",
        "headers": ["Stan", "Decyzja", "Kroki", "Wynik", "Dlaczego jest poprawny"],
        "rows": [
          [
            "Bartek dobrał kafelek Rzeki z fragmentem miasta.",
            "Łączy wodę z biegiem Rzeki i wystawia rycerza w mieście.",
            "1. Dopasowuje wodę. 2. Sprawdza zwykłe krawędzie. 3. Nie stawia figury na wodzie. 4. Sprawdza, że miasto jest wolne, i stawia tam rycerza.",
            "Kafelek Rzeki jest legalnie dołożony, a rycerz legalnie zajmuje miasto.",
            "Woda nie jest zajmowalnym obszarem, lecz inne elementy tego samego kafelka działają normalnie."
          ]
        ]
      },
      {
        "type": "commonMistake",
        "text": "Traktowanie Rzeki jak drogi. Korekta: woda nie jest drogą, nie punktuje jako droga i nie wolno wystawić na niej figury."
      },
      {
        "type": "commonMistake",
        "text": "Połączenie pól po przeciwnych stronach Rzeki bez sprawdzenia grafiki. Korekta: Rzeka rozdziela pola, chyba że kafelek wyraźnie pokazuje ich połączenie."
      },
      {
        "type": "crossReference",
        "sectionId": "tile-legality",
        "label": "Podstawowe dopasowanie kafelków"
      },
      {
        "type": "crossReference",
        "sectionId": "meeple-placement",
        "label": "Wystawianie figury na zwykłych obszarach"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Kafelki Rzeki tworzą bieg od źródła do jeziora.",
          "Woda nie jest drogą i nie można na niej stawiać figur.",
          "Inne tereny na kafelku Rzeki działają normalnie.",
          "Rzeka zwykle rozdziela pola po swoich stronach."
        ]
      },
      {
        "type": "qa",
        "question": "Czy mogę wystawić rycerza na kafelku Rzeki?",
        "answer": "Tak, jeżeli kafelek zawiera wolne miasto. Nie wolno jednak wystawić figury na samej wodzie."
      }
    ]
  },
  {
    "id": "abbot-rules",
    "title": "Opat: klasztory, ogrody i punktowanie",
    "requiredModuleIds": [
      "abbot"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "polish-base-c3"
    ],
    "keywords": [
      "opat",
      "ogrod"
    ],
    "level": "basic",
    "hubGroup": "Opat",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Opat jest dodatkową figurą gracza przeznaczoną wyłącznie do klasztorów i ogrodów. Daje ci kolejną możliwość zajęcia obszaru bez zużywania zwykłej figury, lecz nie może zastępować rycerza, podróżnika ani chłopa. Jego siła wynosi 1, więc przy punktowaniu stosuje się zwykłe zasady większości."
      },
      {
        "type": "paragraph",
        "text": "Po dołożeniu kafelka możesz wystawić Opata na wolnym klasztorze albo ogrodzie na tym kafelku. Nie wolno wystawić go na drodze, w mieście ani na polu. Ogród punktuje jak klasztor: liczy się jego własny kafelek i wszystkie kafelki wokół niego, także po przekątnych."
      },
      {
        "type": "numberedList",
        "items": [
          "Połóż kafelek legalnie.",
          "Wybierz wolny klasztor albo ogród na właśnie dołożonym kafelku.",
          "Wystaw na nim Opata zamiast zwykłej figury.",
          "Gdy obszar jest otoczony ośmioma kafelkami, punktuje za 9 i Opat wraca do zasobu."
        ]
      },
      {
        "type": "table",
        "headers": ["Stan", "Decyzja", "Kroki", "Wynik", "Dlaczego jest poprawny"],
        "rows": [
          [
            "Anna dokłada kafelek z wolnym ogrodem.",
            "Wystawia na ogrodzie Opata.",
            "1. Sprawdza, że ogród nie jest zajęty. 2. Kładzie Opata. 3. Później ósmy sąsiad otacza ogród. 4. Anna dostaje 9 punktów i odzyskuje Opata.",
            "Ogród punktuje tak jak ukończony klasztor.",
            "Opat może zajmować ogród, a liczba punktów zależy od tego samego pełnego otoczenia."
          ]
        ]
      },
      {
        "type": "commonMistake",
        "text": "Wystawienie Opata na polu albo w mieście. Korekta: Opat może stać wyłącznie na klasztorze lub ogrodzie."
      },
      {
        "type": "commonMistake",
        "text": "Pomijanie przekątnych przy ogrodzie. Korekta: ogród liczy osiem sąsiadów dokładnie jak klasztor."
      },
      {
        "type": "crossReference",
        "sectionId": "abbot-recall",
        "label": "Wcześniejsze wycofanie Opata"
      },
      {
        "type": "crossReference",
        "sectionId": "monasteries",
        "label": "Podstawowe liczenie otoczenia klasztoru"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Opat ma siłę 1.",
          "Może zajmować tylko klasztor albo ogród.",
          "Ogród i klasztor liczą osiem sąsiadów.",
          "Po pełnym otoczeniu obszar daje 9 punktów."
        ]
      },
      {
        "type": "qa",
        "question": "Czy Opat może stanąć na drodze?",
        "answer": "Nie. Opat jest przeznaczony wyłącznie dla klasztoru lub ogrodu."
      }
    ]
  },
  {
    "id": "abbot-recall",
    "title": "Opat: wcześniejsze wycofanie zamiast wystawienia",
    "requiredModuleIds": [
      "abbot"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "polish-base-c3"
    ],
    "keywords": [
      "opat"
    ],
    "level": "basic",
    "hubGroup": "Opat",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Opat nie musi czekać na pełne otoczenie klasztoru lub ogrodu. Jeśli w swojej turze nie wystawiasz żadnej figury, możesz zamiast tego wycofać Opata z nieukończonego klasztoru albo ogrodu, wziąć punkty za obecne kafelki i wrócić Opata do zasobu."
      },
      {
        "type": "numberedList",
        "items": [
          "Dołóż kafelek legalnie.",
          "Zdecyduj, że nie wystawiasz żadnej figury w tej turze.",
          "Wycofaj Opata z nieukończonego klasztoru lub ogrodu.",
          "Policz 1 punkt za kafelek Opata oraz 1 za każdego obecnego sąsiada.",
          "Zwróć Opata do zasobu, a potem rozpatrz zwykłe ukończenia wywołane kafelkiem."
        ]
      },
      {
        "type": "warning",
        "text": "Nie można jednocześnie postawić figury i wycofać Opata."
      },
      {
        "type": "table",
        "headers": ["Stan", "Decyzja", "Kroki", "Wynik", "Dlaczego jest poprawny"],
        "rows": [
          [
            "Anna ma Opata w ogrodzie z pięcioma sąsiadami. Nie chce wystawiać nowej figury.",
            "Wycofuje Opata zamiast wystawienia.",
            "1. Dokłada kafelek. 2. Rezygnuje z wystawienia. 3. Liczy ogród: 1 + 5. 4. Dostaje 6 punktów i odzyskuje Opata.",
            "Anna otrzymuje 6 punktów zamiast czekać na pełne 9.",
            "Wcześniejsze wycofanie daje bieżącą wartość otoczenia i zwraca figurę."
          ]
        ]
      },
      {
        "type": "commonMistake",
        "text": "Wystawienie meepla i jednoczesne wycofanie Opata. Korekta: wycofanie zastępuje wystawienie figury."
      },
      {
        "type": "crossReference",
        "sectionId": "abbot-rules",
        "label": "Podstawowe zasady Opata"
      },
      {
        "type": "crossReference",
        "sectionId": "turn-structure",
        "label": "Etap figury w turze"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Wycofanie Opata zastępuje wystawienie figury.",
          "Działa tylko z nieukończonego klasztoru lub ogrodu.",
          "Punkty = 1 + obecni sąsiedzi.",
          "Opat wraca do zasobu."
        ]
      },
      {
        "type": "qa",
        "question": "Czy mogę wycofać Opata i jednocześnie wystawić chłopa?",
        "answer": "Nie. Wycofanie Opata zajmuje cały etap wystawienia figury."
      }
    ]
  },
  {
    "id": "river-abbot-examples",
    "title": "Rzeka — przykłady przy stole",
    "requiredModuleIds": [
      "river"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "corpus-base",
      "polish-base-c3"
    ],
    "keywords": [
      "przyklad",
      "rzeka"
    ],
    "level": "intermediate",
    "hubGroup": "Rzeka",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Poniższe przykłady pokazują, jak Rzeka współgra z podstawą: co wolno stawiać na kafelkach z wodą, jak uniknąć podwójnego zakrętu i kiedy kończy się faza Rzeki. Opat ma własne przykłady w rozdziale Opata."
      },
      {
        "type": "example",
        "title": "Figura przy Rzece",
        "text": "Anna dokłada kafelek Rzeki z segmentem miasta. Może wystawić rycerza w tym mieście, podróżnika na drodze albo chłopa na polu — dokładnie jak na zwykłym kafelku. Nie stawia figury „na wodzie”: rzeka nie jest drogą ani osobnym punktowanym obszarem."
      },
      {
        "type": "example",
        "title": "Zakaz dwóch zakrętów",
        "text": "Bartek chce dołożyć zakręcony kafelek Rzeki zaraz po innym zakręcie w tę samą stronę. Ruch jest nielegalny. Musi wybrać orientację albo inny kafelek, który nie tworzy dwóch kolejnych zakrętów w tym samym kierunku."
      },
      {
        "type": "example",
        "title": "Jezioro kończy Rzekę",
        "text": "Celina dokłada jezioro jako ostatni kafelek Rzeki. Po tej turze (z pełnym rozpatrzeniem ukończeń) kolejni gracze dobierają już ze zwykłej puli podstawy i aktywnych dodatków. Źródła ani jeziora nie wraca się do worka."
      },
      {
        "type": "table",
        "headers": ["Stan", "Decyzja", "Kroki", "Wynik", "Dlaczego jest poprawny"],
        "rows": [
          [
            "Na kafelku Rzeki jest droga i pole; droga jest wolna.",
            "Anna wystawia podróżnika na drodze, nie na rzece.",
            "1. Dokłada kafelek legalnie. 2. Wybiera obszar drogi. 3. Stawia figurę.",
            "Podróżnik stoi na drodze i będzie punktował jak w podstawie.",
            "Rzeka tylko kształtuje mapę; punktują zwykłe tereny na kafelku."
          ]
        ]
      },
      {
        "type": "commonMistake",
        "text": "Traktowanie rzeki jak drogi do punktowania. Korekta: punkty dają drogi, miasta, klasztory i pola narysowane na kafelku, nie sam bieg wody."
      },
      {
        "type": "crossReference",
        "sectionId": "river-rules",
        "label": "Zasady układania Rzeki"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Figury stawiasz na terenach, nie na wodzie.",
          "Nie rób dwóch kolejnych zakrętów w tę samą stronę.",
          "Po jeziorze wracacie do zwykłej puli."
        ]
      },
      {
        "type": "qa",
        "question": "Czy mogę dostać punkty za samą długość rzeki?",
        "answer": "Nie. Rzeka nie jest punktowanym obszarem. Punktują wyłącznie drogi, miasta, klasztory i pola utworzone na jej kafelkach według zasad podstawy."
      }
    ]
  },
  {
    "id": "river-abbot-mistakes",
    "title": "Rzeka — najczęstsze błędy",
    "requiredModuleIds": [
      "river"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "corpus-base",
      "polish-base-c3"
    ],
    "keywords": [
      "bledy",
      "rzeka"
    ],
    "level": "basic",
    "hubGroup": "Rzeka",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Te błędy pojawiają się niemal w każdej pierwszej partii z Rzeką. Sprawdź je przed startem i gdy ktoś zaproponuje „skrót” przy układaniu źródła."
      },
      {
        "type": "commonMistake",
        "text": "Traktowanie rzeki jak drogi. Korekta: woda nie punktuje; punktują tereny na kafelku."
      },
      {
        "type": "commonMistake",
        "text": "Podwójny zakręt w tę samą stronę mimo zakazu. Korekta: dwa kolejne zakręty w tym samym kierunku są nielegalne."
      },
      {
        "type": "commonMistake",
        "text": "Kładzenie zwykłego kafelka startowego obok źródła. Korekta: przy aktywnej Rzece źródło zastępuje start."
      },
      {
        "type": "commonMistake",
        "text": "Mieszanie kafelków Rzeki ze zwykłą pulą przed zakończeniem biegu. Korekta: najpierw cała Rzeka do jeziora, potem zwykła pula."
      },
      {
        "type": "example",
        "title": "Poprawna reakcja",
        "text": "Bartek odkrywa, że chciał dołożyć drugi zakręt w tę samą stronę. Odwołuje ruch, obraca kafelek albo — jeśli żadna legalna orientacja nie istnieje — odkłada go według zasad niemożliwego dołożenia opisanych w podstawie i dobiera następny."
      },
      {
        "type": "crossReference",
        "sectionId": "river-setup",
        "label": "Przygotowanie Rzeki"
      },
      {
        "type": "crossReference",
        "sectionId": "abbot-rules",
        "label": "Osobno: zasady Opata"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Źródło zamiast startu.",
          "Bez podwójnych zakrętów.",
          "Rzeka ≠ droga do punktów."
        ]
      },
      {
        "type": "qa",
        "question": "Czy wolno domieszać kafelki Rzeki do worka podstawy na początku?",
        "answer": "Nie. Kafelki Rzeki rozgrywa się jako osobną sekwencję od źródła do jeziora. Dopiero potem korzystacie ze zwykłej, zakrytej puli."
      }
    ]
  },
  {
    "id": "abbot-examples-mistakes",
    "title": "Opat — przykłady i błędy",
    "requiredModuleIds": [
      "abbot"
    ],
    "editionTag": "C3",
    "sourceIds": [
      "corpus-base",
      "polish-base-c3"
    ],
    "keywords": [
      "opat",
      "przyklad",
      "bledy",
      "ogrod"
    ],
    "level": "intermediate",
    "hubGroup": "Opat",
    "content": [
      {
        "type": "heading",
        "text": "Czego nauczysz się w tym rozdziale",
        "level": 2
      },
      {
        "type": "paragraph",
        "text": "Opat to dodatkowa figura na klasztory i ogrody. Może wrócić wcześniej z punktowaniem częściowym. Poniżej pełne przykłady i typowe pomyłki — bez zmiany procedur z rozdziałów „Opat zasady” i „Opat wycofanie”."
      },
      {
        "type": "example",
        "title": "Wczesne wycofanie",
        "text": "Anna ma Opata na klasztorze z pięcioma sąsiadami. Zamiast czekać na pełne 9, w swojej turze rezygnuje z wystawienia figury, wycofuje Opata i bierze 6 punktów (1 za klasztor + 5 za sąsiadów). Opat wraca do jej zapasu."
      },
      {
        "type": "example",
        "title": "Opat na ogrodzie",
        "text": "Bartek dokłada kafelek z ogrodem i wystawia Opata zamiast zwykłego mnicha. Ogród punktuje jak klasztor: 9 po otoczeniu ośmioma sąsiadami albo wcześniej przy świadomym wycofaniu Opata według zasad wycofania."
      },
      {
        "type": "table",
        "headers": ["Stan", "Decyzja", "Kroki", "Wynik", "Dlaczego jest poprawny"],
        "rows": [
          [
            "Opat Anny stoi na klasztorze z 5 sąsiadami; Anna ma turę i nie chce czekać.",
            "Wycofuje Opata zamiast wystawiać inną figurę w tej turze (zgodnie z procedurą wycofania).",
            "1. Deklaruje wycofanie. 2. Liczy 1 + 5 sąsiadów. 3. Przesuwa znacznik o 6. 4. Bierze Opata do ręki.",
            "Anna ma 6 punktów i wolnego Opata; klasztor może później zająć kto inny zwykłym mnichem, jeśli będzie wolny.",
            "Opat może wrócić wcześniej z punktowaniem za obecne elementy, nie musi czekać na 9."
          ]
        ]
      },
      {
        "type": "commonMistake",
        "text": "Wystawienie Opata na drogę, miasto lub pole. Korekta: Opat staje tylko na klasztorze albo ogrodzie."
      },
      {
        "type": "commonMistake",
        "text": "Wycofanie Opata poza własną turą albo jednocześnie z wystawieniem innej figury w tej samej turze wbrew procedurze. Korekta: stosuj dokładnie rozdział o wycofaniu — to akcja we własnej turze według opisanych ograniczeń."
      },
      {
        "type": "commonMistake",
        "text": "Liczenie wcześniejszego wycofania zawsze jako 9 punktów. Korekta: przy wczesnym powrocie liczysz 1 za klasztor/ogród i 1 za każdego obecnego sąsiada, nie automatyczne 9."
      },
      {
        "type": "crossReference",
        "sectionId": "abbot-rules",
        "label": "Zasady wystawiania Opata"
      },
      {
        "type": "crossReference",
        "sectionId": "abbot-recall",
        "label": "Procedura wycofania Opata"
      },
      {
        "type": "heading",
        "text": "Krótko",
        "level": 2
      },
      {
        "type": "bulletList",
        "items": [
          "Opat: tylko klasztor lub ogród.",
          "Wczesny powrót = punkty za obecnych sąsiadów.",
          "Pełne otoczenie nadal daje 9 jak klasztor."
        ]
      },
      {
        "type": "qa",
        "question": "Czy po wczesnym wycofaniu Opata klasztor jest „zużyty”?",
        "answer": "Nie. Po zdjęciu Opata klasztor lub ogród pozostaje na mapie. Jeśli obszar jest wolny, inny gracz może później wystawić tam legalną figurę według zwykłych zasad."
      }
    ]
  }
];
